export default {"src":"/_next/static/media/discount_tag_64.4cea78ec.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};